module.exports = __webpack_public_path__ + "img/煅石膏.47c234f7.jpg";